import { ReportTableColumn, ReportTableDropdown } from '../../../../models/reports.model';
import { WarehousePropertyDetailMenuEnum } from './warehouse-property-detail.enum';
import { DataType } from "src/app/common/models/enums/common.enum";

/**
 * This class contains static constants used for configuring
 * the Warehouse Property Detail report UI, including menu options,
 * dropdowns, and table column definitions for different views.
 */
export class WarehousePropertyDetailConstant {
  /**
   * Menu options for the warehouse property detail overview section.
   * Each menu item has a label (for translation) and a corresponding enum value.
   */
  static overViewMenu = [
    {
      label: 'reports.overview',
      name: WarehousePropertyDetailMenuEnum.overview,
    },
    {
      label: 'reports.rentUnitSizeWise',
      name: WarehousePropertyDetailMenuEnum.rentUnitSizeWise,
    }
  ];

  /**
   * Dropdown configuration for selecting price display type (Range or Average)
   * in the "Rent Unit Size Wise" report section.
   */
  static rentUnitSizeWiseDropdown: ReportTableDropdown = {
    label: 'reports.show_price_in',
    data: [
      {
        value: 'Range',
        id: 'Range',
      },
      {
        value: 'Average',
        id: 'Average',
      },
    ],
    default: 'Range',
    maxSelect: 1,
    reportType: false,
  };

  /**
   * Table column definitions for the "Rent Unit Size Wise" report
   * when displaying price as a range.
   */
  static rentUnitSizeWiseColumnRange: ReportTableColumn[] = [
    {
      header: 'unit_size',
      columnName: 'reports.unit_size',
      field: 'unit_size',
      isSortable: false,
      border: false,
      symbol: DataType.squareMeter,
      isContainsHTML: false,
      convertNumber: false,
    },
    {
      header: 'dry_warehouse_range',
      columnName: 'reports.dry_warehouse',
      field: 'dry_warehouse_range',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'dry_warehouse_avg',
    },
    {
      header: 'cold_storage_range',
      columnName: 'reports.cold_storage',
      field: 'cold_storage_range',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'cold_storage_avg',
    },
    {
      header: 'frozen_warehouse_range',
      columnName: 'reports.frozen_warehouse',
      field: 'frozen_warehouse_range',
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'frozen_warehouse_avg',
    },
    {
      header: 'ambient_range',
      columnName: 'reports.ambient',
      field: 'ambient_range',
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'ambient_avg'
    }
  ];

  /**
   * Table column definitions for the "Rent Unit Size Wise" report
   * when displaying price as an average.
   */
  static rentUnitSizeWiseColumnAverage: ReportTableColumn[] = [
    {
      header: 'unit_size',
      columnName: 'reports.unit_size',
      field: 'unit_size',
      isSortable: false,
      border: false,
      symbol: DataType.squareMeter,
      isContainsHTML: false,
      convertNumber: false,
    },
    {
      header: 'dry_warehouse_avg',
      columnName: 'reports.dry_warehouse',
      field: 'dry_warehouse_avg',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: true,
      toolTipField: 'dry_warehouse_range',
    },
    {
      header: 'cold_storage_avg',
      columnName: 'reports.cold_storage',
      field: 'cold_storage_avg',
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: true,
      toolTipField: 'cold_storage_range',
    },
    {
      header: 'frozen_warehouse_avg',
      columnName: 'reports.frozen_warehouse',
      field: 'frozen_warehouse_avg',
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: true,
      toolTipField: 'frozen_warehouse_range',
    },
    {
      header: 'ambient_avg',
      columnName: 'reports.ambient',
      field: 'ambient_avg',
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: true,
      toolTipField: 'ambient_range',
    }
  ];
}